import React from "react";
import { whyChooseUs } from "../mock";
import { ShieldCheck, BadgeCheck, Leaf, PoundSterling, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const iconMap = { ShieldCheck, BadgeCheck, Leaf, PoundSterling };

const WhyChooseUs = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 bg-brand-dark relative overflow-hidden">
      {/* Subtle radial highlight */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-yellow/5 to-transparent pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="text-brand-yellow text-sm font-bold tracking-[0.3em] mb-4">
              WHY CHOOSE US?
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] mb-6">
              RELIABLE. PROFESSIONAL. QUALITY WORK.
            </h2>
            <p className="text-gray-300 text-base md:text-lg mb-10 leading-relaxed max-w-lg">
              We take pride in delivering high standards, honest advice and reliable service on every project, big or small.
            </p>
            <Button
              onClick={() => scrollTo("about")}
              className="bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-bold tracking-wider text-sm px-8 py-7 rounded-md group"
            >
              LEARN MORE ABOUT US
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {whyChooseUs.map((item) => {
              const Icon = iconMap[item.icon];
              return (
                <div
                  key={item.id}
                  className="bg-brand-dark-2 border border-white/5 rounded-lg p-7 hover:border-brand-yellow/40 hover:bg-brand-dark-3 transition-all duration-300 group cursor-pointer"
                >
                  {Icon && (
                    <Icon
                      className="text-brand-yellow mb-6 group-hover:scale-110 transition-transform"
                      size={30}
                    />
                  )}
                  <h3 className="font-display text-lg text-white tracking-wide mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
